import { Entity } from 'src/app/core/data/schema/entity';
import { RaffleAccessLevel } from './raffle';

export class RaffleAdmin extends Entity {


    static idField = 'raffleAdminId';
    static controller = 'raffleAdmins';
    static className = 'RaffleAdmin';

    raffleAdminId: number;
    raffleId: number;
    userId: number | null;
    email: string;
    invitedBy: number | null;
    invitedOn: string;
    accessLevel: RaffleAccessLevel;

    constructor(data?: Partial<RaffleAdmin>) {
        super(RaffleAdmin.className, RaffleAdmin.idField, RaffleAdmin.controller);
        Object.assign(this, data);
    }

    static async fetchForRaffle(raffleId: number) {
        return await this.fetchArray(this, this.controller, `${this.controller}/forraffle/${raffleId}`);
    }

    static async fetchAccessLevel(raffleId: number) {
        return await this.fetchUntyped(null, this.controller, `accesslevel/${raffleId}`, 'text', true) as RaffleAccessLevel;
    }
}
